// Netlify Image CDN helper — available on every Netlify deploy at /.netlify/images.
// Remote/absolute URLs are returned untouched so existing artifact links keep working.
export function optimizedImage(src, { width, height, fit = "cover", format = "webp", quality = 78 } = {}) {
  if (!src || /^https?:\/\//i.test(src)) return src;

  const params = new URLSearchParams({ url: src });
  if (width) params.set("w", String(width));
  if (height) params.set("h", String(height));
  if (width && height) params.set("fit", fit);
  params.set("fm", format);
  params.set("q", String(quality));

  return `/.netlify/images?${params.toString()}`;
}
